import React from "react";
import FilterButtons from "Components/Fragment/FilterButtons";
import * as CONSTANTS from "../../constants";

const ToggleButtonGroupStatus = ({ value, languageContext, onClick }) => {
  const buttons = [
    { value: languageContext("all"), filter: CONSTANTS.PROGRESS_ALL },
    { value: `${languageContext("lefttodo")}`, filter: CONSTANTS.FILTER_TODO },
    { value: `${languageContext("begun")}`, filter: CONSTANTS.FILTER_ONGOING },
    {
      value: `${languageContext("Finished2")}`,
      filter: CONSTANTS.FILTER_DONE,
    },
  ];

  return (
    <FilterButtons value={value} buttons={buttons} onSelectFilter={onClick} />
  );
};

export default ToggleButtonGroupStatus;
